// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xF31p","item-contanier":"styles_item-contanier__1ibx0"};